import { useCallback } from 'react'

import { addDays } from 'date-fns'

import { useCookies } from '@/utils/hooks/useCookies'

import {
  AUTHORIZATION_COOKIE_KEY,
  REMEMBER_ME_COOKIE_KEY,
} from '@/blocks/Auth/definitions'

export const useAuthCookieManager = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    AUTHORIZATION_COOKIE_KEY,
    REMEMBER_ME_COOKIE_KEY,
  ])

  const saveAuthCookie = useCallback(({
    cookieName,
    token,
    temporary = false,
    expiresInDays,
    isDocToken = false,
    isAutoShare = false,
    estimateType,
    browserType,
  }) => {
    const cookieData = JSON.stringify({
      token,
      temporary,
      isDocToken,
      isAutoShare,
      estimateType,
      browserType,
    })
    setCookie(cookieName, cookieData, {
      path: '/',
      expires: expiresInDays ? addDays(new Date(), expiresInDays) : undefined,
    })
  }, [setCookie])

  const removeAuthCookies = useCallback((authCookieNames) => {
    authCookieNames.forEach((authCookieName) => removeCookie(authCookieName))
  }, [removeCookie])

  const getAuthTokenFromCookie = (cookieName) => {
    const auth = getAuthFromCookie(cookieName)
    return auth && auth.token ? auth.token : null
  }

  const getAuthFromCookie = (cookieName) => {
    return cookies[cookieName] ?? {}
  }

  const hasAuthCookie = !!cookies?.authorization?.token

  return {
    saveAuthCookie,
    removeAuthCookies,
    getAuthTokenFromCookie,
    getAuthFromCookie,
    hasAuthCookie,
  }
}
